export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const REGISTER = 'register'
export const HELP = 'help'

export default {

    noFooter (state, payload) {
        state.noFooter = payload || false
    },
    noHeader (state, payload) {
        state.noHeader = payload || false
    },
    headerTitle (state, payload) {
        state.headerTitle = payload || ''
    },
}
